/**
 * InfoList 정보 목록
 * cjfw-fsmns-mo-pub
 *
 * @author 김정웅
 */
import React from 'react'

import { Text, New, StatusLabel } from 'components'

function Element({ className, data = [], onClick = () => {} }) {
  return (
    <ul className={'basic-list ' + className}>
      {data.map((item) => (
        // type 1
        <li key={item.id} onClick={() => onClick(item)}>
          <StatusLabel color={item.status.color} text={item.status.title} />
          <p className="f-medium mt8">
            {item.title}
            <New confirmYn={item.cnfrmYn} />
          </p>

          <Text className="mt8 c-6 f-12">{item.prod}</Text>
          <div className="info-area mt4">
            {typeof item?.username !== 'undefined' && <Text>{item.username}</Text>}
            <Text>{item.date}</Text>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default Element
